var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvertCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15C22.5 18.87 19.37 22 15.5 22L16.55 20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9C2.5 5.13 5.63 2 9.5 2L8.45 3.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.2V4.31C22.5 4.59 22.28 4.81 22 4.81H13C12.72 4.81 12.5 4.59 12.5 4.31V4.2C12.5 2.44 12.94 2 14.72 2H20.28C22.06 2 22.5 2.44 22.5 4.2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.81C12.72 5.81 12.5 6.03 12.5 6.31V7.31V8.3C12.5 10.06 12.94 10.5 14.72 10.5H20.28C22.06 10.5 22.5 10.06 22.5 8.3V7.31V6.31C22.5 6.03 22.28 5.81 22 5.81H13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.7V15.81C12.5 16.09 12.28 16.31 12 16.31H3C2.72 16.31 2.5 16.09 2.5 15.81V15.7C2.5 13.94 2.94 13.5 4.72 13.5H10.28C12.06 13.5 12.5 13.94 12.5 15.7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.3101C2.72 17.3101 2.5 17.5301 2.5 17.8101V18.8101V19.8001C2.5 21.5601 2.94 22.0001 4.72 22.0001H10.28C12.06 22.0001 12.5 21.5601 12.5 19.8001V18.8101V17.8101C12.5 17.5301 12.28 17.3101 12 17.3101H3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertCard);
export default __webpack_public_path__ + "static/media/convert-card.f2e717cb3bcc816e26d198a587d18fb9.svg";
export { ForwardRef as ReactComponent };